<template>
    <input class="form-control t_right" type="text" :disabled="disabled" />
</template>

<script>
    import 'jquery-maskmoney/src/jquery.maskMoney'

    export default {
        props: {
            value: {
                type: [ Number, String ],
                default: () => 0
            },
            disabled: {
                type: Boolean,
                default: () => false
            },
            thousands: {
                type: String,
                default: () => '.'
            },
            decimal: {
                type: String,
                default: () => ','
            },
            precision: {
                type: Number,
                default: () => 2
            },
            allowNegative: {
                type: Boolean,
                default: () => false
            },
            allowZero: {
                type: Boolean,
                default: () => true
            }
        },
        mounted () {
            this.initMask()
        },
        watch: {
            value (val) {
                this.setModel(val)
            }
        },
        methods: {
            initMask () {
                window.jQuery(this.$el).maskMoney({
                    thousands: this.thousands,
                    decimal: this.decimal,
                    precision: this.precision,
                    allowZero: this.allowZero,
                    allowNegative: this.allowNegative
                })
                window.jQuery(this.$el).on('keyup', () => {
                    this.$emit('input', this.getFloatVal())
                })
                window.jQuery(this.$el).on('blur', () => {
                    this.$emit('blur')
                })
                window.jQuery(this.$el).maskMoney('mask', this.value)
                this.$emit('input', this.getFloatVal())
            },
            setModel (val) {
                window.jQuery(this.$el).maskMoney('mask', val)
                this.$emit('input', this.getFloatVal())
            },
            getFloatVal () {
                return parseFloat(window.jQuery(this.$el).val().replace('.', '').replace(',', '.'))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/Numeric.vue